import Modal from '../../../shared/UI/Modal'

type Props = {
    titleText: string
    buttonLabel: string
    message: string
    open: boolean
    type: 'clash' | 'question'
    isDisabled: boolean
    onClose: () => void
    onClick?: () => void
}

function BookingNotification ({ titleText, buttonLabel, message, open, type, isDisabled, onClose, onClick }: Props) {

    return (
      <Modal
        data-testid="desk-booking-modal"
        type={type}
        open={open}
        onClose={onClose}
        onClick={onClick}
        title={titleText}
        buttonLabel={buttonLabel}
        isDisabled={isDisabled}
        message={message}
        maxWidth='md'
        cancelButtonStyle={{textTransform: 'none'}}
        confirmButtonStyle={{textTransform: 'none'}}
      />
    )
}

export default BookingNotification
